module.exports = __webpack_public_path__ + "images/rich_heading/small_appliance/e_book_reader/icon_ccd5dc10ff02d788b76c5b9219aae4d8.png";